import React, { useState } from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import UiButton from "../../common/UiButton";
import UiArrowIcon from "../../common/UiArrowIcon";
import ProjectType from "../../../types/Project";
import { tableRowActionButtonModernStyle } from "../../common/tableTheme";

interface PropTypes extends RouteComponentProps<any>, React.Props<any> {
  project: ProjectType;
  history: any;
  classes: any;
  isAdmin: boolean;
  hideImport?: boolean;
  showBatches?: boolean;
  variant?: "default" | "modern";
}

const styles = (theme: Theme) =>
  createStyles({
    fixedWidth: {
      paddingRight: theme.spacing.unit * 2,
    },
    actionButtonModern: tableRowActionButtonModernStyle(theme),
  });

const ProjectActionButton = (props: PropTypes) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const {
    project,
    history,
    classes,
    isAdmin,
    hideImport,
    showBatches,
    variant = "default",
  } = props;
  const isModern = variant === "modern";

  const onMenuClick = (event: any, index: any) => {
    if (index === 0) {
      const importType = () => {
        switch (project.dataSource || "") {
          case "S3":
            return project.labelingType === "VIDEO" ? "video" : "dossierlocal";
          case "LABELS":
            return "labels";
          default:
            return "dossierlocal";
        }
      };
      history.push(`/projects/${project.id}/import/${importType()}`);
    } else if (index === 1) {
      history.push(`/projects/${project.id}/batches/create`);
    } else if (index === 2) {
      history.push(`/project/${project.id}?view=form`);
    } else {
      history.push(`/project/${project.id}?view=users`);
    }
    closeMenu();
  };

  const actionButtonClicked = (e: any) => setAnchorEl(e.currentTarget);

  const closeMenu = () => setAnchorEl(null);

  return (
    <React.Fragment>
      <UiButton
        variant="outlined"
        color="secondary"
        onClick={(e: any) => actionButtonClicked(e)}
        className={classNames({
          [classes.fixedWidth]: !isModern,
          [classes.actionButtonModern]: isModern,
        })}
      >
        Actions
        <UiArrowIcon />
      </UiButton>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        disableAutoFocusItem
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {showBatches && (
          <MenuItem
            key={0}
            onClick={() => {
              history.push(
                `/batches/0?projectId=${project.id}&sort=createdDate,desc`,
              );
              closeMenu();
            }}
          >
            Afficher les lots
          </MenuItem>
        )}
        {!hideImport && !showBatches && (
          <MenuItem key={0} onClick={(e: any) => onMenuClick(e, 0)}>
            {project.dataSource === "LABELS"
              ? "Créer les lots"
              : project.labelingType === "VIDEO"
                ? "Importer les vidéos"
                : "Importer les images"}
          </MenuItem>
        )}
        {project.dataSource !== "LABELS" && (
          <MenuItem
            key={1}
            onClick={(e: any) => onMenuClick(e, 1)}
            disabled={project.stagingFolders.length === 0}
          >
            Générer des lots
          </MenuItem>
        )}
        {isAdmin && (
          <MenuItem key={2} onClick={(e: any) => onMenuClick(e, 2)}>
            Modifier le projet
          </MenuItem>
        )}
        {isAdmin && (
          <MenuItem key={1} onClick={(e: any) => onMenuClick(e, 3)}>
            Utilisateurs du projet
          </MenuItem>
        )}
      </Menu>
    </React.Fragment>
  );
};

export default withStyles(styles)(withRouter(ProjectActionButton));
